import { render, staticRenderFns } from "./LogoEditView.vue?vue&type=template&id=4f57e094&scoped=true&"
import script from "./LogoEditView.vue?vue&type=script&lang=ts&"
export * from "./LogoEditView.vue?vue&type=script&lang=ts&"
import style0 from "./LogoEditView.vue?vue&type=style&index=0&id=4f57e094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57e094",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f57e094')) {
      api.createRecord('4f57e094', component.options)
    } else {
      api.reload('4f57e094', component.options)
    }
    module.hot.accept("./LogoEditView.vue?vue&type=template&id=4f57e094&scoped=true&", function () {
      api.rerender('4f57e094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/logo/LogoEditView.vue"
export default component.exports